import { create } from 'zustand';

export const useNativeStore = create((set) => ({
    isNative: false,
    setIsNative: (status) => set({ isNative: status }),
}));
